import "./css/index.css";
import React, { FC } from "react";
import classNames from "classnames";
import { ODSBreadcrumbProps } from "./ODSBreadcrumb.types";
import {
  generateBreadcrumbGroups,
  generateBreadcrumbGroupsOptions,
} from "./ODSBreadcrumb.utils";
import ODSBreadcrumbItem from "./ODSBreadcrumbItem";
import ODSBreadcrumbOverflowItem from "./ODSBreadcrumbOverflowItem";
import ODSBreadcrumbSeparatorDot from "./ODSBreadcrumbSeparatorDot";
import { useViewportSize } from "@/utils";

const ODSBreadcrumb: FC<ODSBreadcrumbProps> = ({
  className,
  items,
  showMoreLabel = "Show more paths",
  ...rest
}) => {
  const viewportSize = useViewportSize();
  const groupsOptions = generateBreadcrumbGroupsOptions(viewportSize);
  const { firstGroup, overflowGroup, secondGroup } = generateBreadcrumbGroups(
    items,
    groupsOptions
  );
  return (
    <nav
      className={classNames(`ODSBreadcrumb`, className)}
      aria-label="Breadcrumb"
      {...rest}
    >
      <ol className="ODSBreadcrumb-List">
        {firstGroup?.map((itemProps, index) => {
          const isLast = index + 1 === firstGroup?.length;
          return (
            <li
              className="ODSBreadcrumb-List-Item"
              key={`ODSBreadcrumb-List-First-Group-Item_${index}`}
            >
              <ODSBreadcrumbItem
                {...itemProps}
                selected={!secondGroup?.length && isLast}
              />
              {!isLast ? (
                <ODSBreadcrumbSeparatorDot
                  className="ODSBreadcrumb-Separator"
                  aria-hidden="true"
                />
              ) : null}
            </li>
          );
        })}

        {overflowGroup?.length ? (
          <li className="ODSBreadcrumb-List-Item">
            <ODSBreadcrumbOverflowItem
              items={overflowGroup}
              title={showMoreLabel}
              aria-label={showMoreLabel}
            />
          </li>
        ) : null}

        {secondGroup?.map((itemProps, index) => {
          const isLast = index + 1 === secondGroup?.length;
          return (
            <li
              className="ODSBreadcrumb-List-Item"
              key={`ODSBreadcrumb-List-Second-Group-Item_${index}`}
            >
              <ODSBreadcrumbItem {...itemProps} selected={isLast} />
              {!isLast ? (
                <ODSBreadcrumbSeparatorDot
                  className="ODSBreadcrumb-Separator"
                  aria-hidden="true"
                />
              ) : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default ODSBreadcrumb;
